
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://isdsolqaridrenerpfgz.supabase.co';
const supabaseAnonKey = 'sb_publishable_cE-RvO9B67HbKKmVqGdBKQ_tENRLNRI';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
